const CHANGELOG_ENTRIES = [
    {
        id: '2026-10-12-mobile-navigation-and-account',
        date: '2026-10-12',
        dateLabel: 'October 12, 2026',
        title: 'Quicker navigation and clearer account actions',
        summary:
            'Return to recent folders faster and find the right action for your membership.',
        changes: [
            'Cached recent folders load before mobile navigation opens.',
            'Slide across supported header tabs on iPhone to switch between them.',
            'Account shows clearer Upgrade, Manage, and purchase-history actions for your membership.',
            'Email readers follow your active light or dark appearance, and browser menus handle keyboard and sheet transitions more reliably.',
            'Saved social previews can recover expired thumbnail images more reliably.',
            'Copying selected messages with macOS desktop shortcuts works more reliably.'
        ]
    },
    {
        id: '2026-10-11-mobile-notes-and-reading',
        date: '2026-10-11',
        dateLabel: 'October 11, 2026',
        title: 'Copy your drafts and take notes with you',
        summary:
            'Export a mobile note as Markdown and keep editing comfortably across keyboard and appearance changes.',
        changes: [
            'Copy the current note draft or export it as a Markdown file from the mobile editor.',
            'Dismissing the keyboard keeps your note editing session open.',
            'Message previews, conversations, and action menus are easier to read in light mode.',
            'Returning from fullscreen video on iPhone restores the message sheet position.',
            'Saved X articles preserve embedded posts in supported web readers; older articles may need re-extraction.',
            'Mobile web sidebar controls respond to taps more reliably.'
        ]
    },
    {
        id: '2026-10-10-recents-and-mobile-actions',
        date: '2026-10-10',
        dateLabel: 'October 10, 2026',
        title: 'Recent folders follow you across devices',
        summary:
            'Pick up recent folders on web and mobile, with smoother mobile actions and media previews.',
        changes: [
            'Mobile folder Recents shares history with the web sidebar and keeps cached folders available offline.',
            'Mobile sharing, reminders, attachment options, and message actions use more consistent sheets.',
            'Android keyboard movement is smoother in supported composers and forms.',
            'Portrait video cards are more compact, and reply previews have room to show their content.',
            'Image attachments open correctly from the web Workspace.'
        ]
    },
    {
        id: '2026-10-09-profile-reminders-and-readable-links',
        date: '2026-10-09',
        dateLabel: 'October 9, 2026',
        title: 'Less account upkeep and clearer reminders',
        summary:
            'Save profile changes with fewer steps and see clearer dates and text in your saved material.',
        changes: [
            'Profile names save when you leave the field, photos upload when selected, and mobile timezone changes save immediately.',
            'Reminder cards show the actual scheduled time, while Past and Next tabs make reminders easier to browse.',
            'Automatic reminder review prompts appear only when reminder intent is confirmed.',
            'Saved links and filenames display readable international characters instead of encoded text.',
            'Mobile search-engine choices show recognizable logos.',
            'Mobile scrolling is less likely to open a message accidentally, and replies are available across reminder, task, and starred views.'
        ]
    },
    {
        id: '2026-10-08-spoken-language-preferences',
        date: '2026-10-08',
        dateLabel: 'October 8, 2026',
        title: 'Set the languages you speak once',
        summary:
            'Give voice-note transcription useful language hints without changing the language of the app.',
        changes: [
            'Choose one or more spoken languages in a searchable Settings picker.',
            'One selected language supplies the default transcription hint; several or none use automatic detection.',
            'Mobile recordings inherit your saved preferences, with existing retranscription controls available when you need a different choice.',
            'Spoken-language preferences are separate from your Luckynote interface language.'
        ]
    },
    {
        id: '2026-10-07-voice-recovery-and-wallpapers',
        date: '2026-10-07',
        dateLabel: 'October 7, 2026',
        title: 'Recover voice notes and keep your backgrounds',
        summary:
            'Keep recoverable audio on your device and return to uploaded wallpapers after switching backgrounds.',
        changes: [
            'Find local voice-note recovery copies in Account → Advanced → Voice note backups, with playback and audio export.',
            'Offline voice captures can wait for reconnection, including multiple recordings saved locally.',
            'Uploaded wallpapers stay in your saved background history when you choose another background.',
            'Automatic reminders better interpret dates and times in supported languages when enabled.',
            'Typing in mobile AI chat is more responsive while an answer is streaming.',
            'Use Cmd+period on the macOS desktop app to dismiss the message panel.'
        ]
    },
    {
        id: '2026-10-06-iphone-capture-and-mobile-layouts',
        date: '2026-10-06',
        dateLabel: 'October 6, 2026',
        title: 'Capture from iPhone widgets and Shortcuts',
        summary:
            'Reach Inbox capture from your Home Screen and fit Luckynote into your Apple Shortcuts workflows.',
        changes: [
            'Add Home Screen widgets for a message, a voice note, or both Inbox capture actions.',
            'Use Apple Shortcuts to save text, supplied audio, or screenshots into Inbox.',
            'Supported iPhone voice capture includes Lock Screen and Dynamic Island recording controls.',
            'Mobile folder actions live in context menus, with layout choices grouped in filters.',
            'Mobile rotation, keyboard spacing, and selection menus behave more consistently.',
            'Web quoted-post previews are more compact, and moving messages updates their destination folder more reliably.'
        ]
    },
    {
        id: '2026-10-05-folder-links-and-bulk-actions',
        date: '2026-10-05',
        dateLabel: 'October 5, 2026',
        title: 'Keep shared folders close and copy more at once',
        summary:
            'Save live folder links, configure collaboration, and copy useful material from several selected notes.',
        changes: [
            'Save a live public or shared folder link to Luckynote and add it to Favorites without copying its messages.',
            'Published folders can offer signed-in viewing, adding, or editing, with a separate option for anonymous text contributions.',
            'Copy selected transcripts or extracted image text together, combine selected images into one image, or download original images as a ZIP on web.',
            'Find forwarded emails through the Emails content filter and Types picker.',
            'Library separates saved material from actionable Tasks lists.',
            'Saved Reddit videos play more reliably on web.'
        ]
    },
    {
        id: '2026-10-04-email-and-richer-previews',
        date: '2026-10-04',
        dateLabel: 'October 4, 2026',
        title: 'Bring email into your Inbox',
        summary:
            'Personal email forwarding adds another way to save, with clearer reading and richer link previews.',
        changes: [
            'Where email forwarding is enabled for your account, use a personal receiving address to save emails and supported attachments into Inbox.',
            'Switch between an email’s original design and a clean reading view on web and mobile, keeping your own notes separate.',
            'Manage connections from dedicated integration settings views.',
            'Supported GitHub repository links offer ZIP attachments, with an automatic download preference.',
            'Spotify links show more accurate titles and artwork, while supported book, movie, and place mentions resolve more useful details.',
            'Saved articles display tables more consistently.'
        ]
    },
    {
        id: '2026-10-03-whatsapp-and-shared-workspaces',
        date: '2026-10-03',
        dateLabel: 'October 3, 2026',
        title: 'Save from WhatsApp and open shared workspaces',
        summary:
            'Connect WhatsApp for Inbox capture and browse shared material in familiar workspace views.',
        changes: [
            'Connect WhatsApp from Integrations to save supported messages and media into Luckynote.',
            'Shared folders and messages use the regular Workspace with clearer access and navigation.',
            'Mixed image and video galleries open more consistently in Workspace.',
            'Supported X article videos play inline in web readers, and mobile article previews avoid duplicate video entries.'
        ]
    },
    {
        id: '2026-10-02-languages-and-workspace',
        date: '2026-10-02',
        dateLabel: 'October 2, 2026',
        title: 'Luckynote in your language, with a clearer workspace',
        summary:
            'Use Luckynote in German or Spanish and enjoy a clearer, more responsive workspace.',
        changes: [
            'Choose English, German, or Spanish in app preferences. German and Spanish are in Beta, with an easy way to report translation issues.',
            'Mobile welcome screens now follow your language choice.',
            'Workspace controls are easier to read over photo backgrounds, and Daily Review shows familiar icons for your saved sources.',
            'Typing and browsing image-heavy folders feel smoother on desktop.',
            'Find the latest product updates beside the app version in Settings.'
        ]
    },
    {
        id: '2026-10-02-ai-models-and-reanalysis',
        date: '2026-10-02',
        dateLabel: 'October 2, 2026',
        title: 'More AI choices and better saved recommendations',
        summary:
            'Find the right AI model for your conversation and get more useful details from saved social posts.',
        changes: [
            'Choose from more AI models, including GPT-6, Claude, and Gemini options available on your plan.',
            'Search for a model directly from the Chat tab in a saved note.',
            'Re-analyse saved carousels to pick up missed recommendations for books, apps, products, places, movies, and shows.'
        ]
    },
    {
        id: '2026-09-30-reading-and-workspace',
        date: '2026-09-30',
        dateLabel: 'September 30, 2026',
        title: 'Read and organize without losing your place',
        summary:
            'Read articles alongside your notes and arrange your folders the way you want.',
        changes: [
            'Open saved articles in your workspace with the original note beside them.',
            'Arrange messages manually in Chat and List views as well as Board.',
            'See your next renewal date or when your subscription access ends in Billing & Usage.'
        ]
    },
    {
        id: '2026-09-30-transcription-reliability',
        date: '2026-09-30',
        dateLabel: 'September 30, 2026',
        title: 'More reliable video and voice transcripts',
        summary:
            'Turn saved videos and voice notes into readable text more reliably.',
        changes: [
            'Transcription is more reliable for supported Instagram, TikTok, and YouTube videos.',
            'Telegram voice-note transcripts appear as replies to the original recording.',
            'Re-analyse supported saved videos when you want to refresh their extracted details.'
        ]
    },
    {
        id: '2026-09-29-library-and-recommendations',
        date: '2026-09-29',
        dateLabel: 'September 29, 2026',
        title: 'Keep saved recommendations in your Library',
        summary:
            'Find places to visit and movies or shows to watch without digging through every saved post.',
        changes: [
            'When Library analysis is enabled, recommendations from supported saves appear as individual items.',
            'Open an item to see its details and the original note where you found it.',
            'Saved Google Maps links can include useful place details.',
            'Browse separate recommendations from supported social carousels.'
        ]
    },
    {
        id: '2026-09-27-google-and-apple-sign-in',
        date: '2026-09-27',
        dateLabel: 'September 27, 2026',
        title: 'A quicker way to sign in',
        summary:
            'Google and Apple sign-in offer familiar ways to access Luckynote on web and mobile.',
        changes: [
            'Choose Google or Apple on the login or registration screen where available.',
            'Use Apple’s Hide My Email option to keep your email address private.'
        ]
    },
    {
        id: '2026-09-26-ai-chat-context',
        date: '2026-09-26',
        dateLabel: 'September 26, 2026',
        title: 'Bring your saved material into AI chat',
        summary:
            'Ask questions with your notes, images, documents, and transcripts close at hand.',
        changes: [
            'Use /context to choose specific notes or relevant material from the whole thread.',
            'Attach images and files directly to a conversation.',
            'Use selected images, documents, and saved transcripts as context with supported models.'
        ]
    },
    {
        id: '2026-09-24-everyday-workflows',
        date: '2026-09-24',
        dateLabel: 'September 24, 2026',
        title: 'Small improvements to everyday saving',
        summary:
            'Rename attachments and keep your place while browsing older saves.',
        changes: [
            'Rename saved files and images from their action menu.',
            'Keep browsing older Inbox messages after opening a preview.',
            'Move folders from the sidebar more reliably.'
        ]
    },
    {
        id: '2026-09-21-export-and-workspace',
        date: '2026-09-21',
        dateLabel: 'September 21, 2026',
        title: 'Take your notes with you',
        summary:
            'Export your saved material with clearer choices and return to a note’s workspace from its link.',
        changes: [
            'Choose whether to include files and media when exporting your account or a folder.',
            'Follow account export progress in Settings and cancel an export you no longer need.',
            'Links to notes opened in the workspace bring you back to the same workspace view.'
        ]
    },
    {
        id: '2026-09-14-gallery-downloads-and-uploads',
        date: '2026-09-14',
        dateLabel: 'September 14, 2026',
        title: 'Easier gallery downloads and uploads',
        summary:
            'Save a whole image gallery at once and keep adding files while an upload is in progress.',
        changes: [
            'Download the images from a saved gallery together as a ZIP file.',
            'Add more files while others are uploading; the new files join the upload queue.',
            'Media previews handle saved videos more consistently.'
        ]
    },
    {
        id: '2026-09-07-sharing-and-folder-shortcuts',
        date: '2026-09-07',
        dateLabel: 'September 7, 2026',
        title: 'Keep shared notes and organize your shortcuts',
        summary:
            'Keep a personal copy of a shared note and make your most-used folders easier to reach.',
        changes: [
            'Save a message from a shared folder to your own Inbox as an independent copy.',
            'Filter your Tasks and Stars by content type and browse more results as you scroll.',
            'Drag folders into Favorites and rearrange your shortcuts.'
        ]
    },
    {
        id: '2026-08-29-daily-review-and-wallpapers',
        date: '2026-08-29',
        dateLabel: 'August 29, 2026',
        title: 'A clearer Daily Review and a background that suits you',
        summary:
            'See where your daily saves came from and choose how your workspace background looks.',
        changes: [
            'Daily Review includes source charts and clearer ways to explore related saves.',
            'Expand review themes to revisit the notes behind them.',
            'Choose the built-in wallpaper, your own image, or no background, and dim your wallpaper on web.'
        ]
    },
    {
        id: '2026-08-24-favorites-and-social-previews',
        date: '2026-08-24',
        dateLabel: 'August 24, 2026',
        title: 'Your favorite folders, closer at hand',
        summary:
            'Reach favorite folders from the sidebar and see more of the social posts you save.',
        changes: [
            'Browse your favorite folders directly in the sidebar.',
            'Sharing indicators make it easier to see which notes and folders are shared.',
            'Saved X posts show more quoted content, while Reddit galleries and Instagram video previews are more reliable.'
        ]
    },
    {
        id: '2026-08-13-reading-listening-and-chat',
        date: '2026-08-13',
        dateLabel: 'August 13, 2026',
        title: 'More ways to read, listen, and revisit',
        summary:
            'Extract text from saved media, listen to articles, and return to earlier AI conversations.',
        changes: [
            'Extract and copy text from supported saved carousels, with an option to do it automatically.',
            'Scan supported saved videos for on-screen text.',
            'Create an audio version of an article with text-to-speech where available.',
            'Revisit earlier AI conversations and their referenced notes more easily.'
        ]
    },
    {
        id: '2026-08-02-reddit-and-connected-ai',
        date: '2026-08-02',
        dateLabel: 'August 2, 2026',
        title: 'Readable Reddit saves and more helpful AI connections',
        summary:
            'Keep Reddit posts in a readable form and let connected AI tools help maintain your notes.',
        changes: [
            'Saved Reddit posts can open as readable articles.',
            'Connected AI tools can create and edit notes when you grant write access.',
            'Ask a connected tool to move a note to Trash or restore it.'
        ]
    },
    {
        id: '2026-07-30-multiple-reminder-alerts',
        date: '2026-07-30',
        dateLabel: 'July 30, 2026',
        title: 'Set more than one reminder for a note',
        summary:
            'Give yourself a heads-up before a due date, then another reminder when it matters.',
        changes: [
            'Add up to five alerts to one reminder.',
            'Choose push or email delivery for each alert.'
        ]
    },
    {
        id: '2026-07-14-daily-review',
        date: '2026-07-14',
        dateLabel: 'July 14, 2026',
        title: 'Daily Review turns saved notes into a recap',
        summary:
            'Luckynote can now generate a day-by-day AI recap of what you saved, with both an in-app review feed and optional digest emails.',
        changes: [
            'Open a new Daily Review page to read AI-written summaries of what you saved each day, and optionally receive the recap by email.',
            'Daily reviews group saved material by day so it is easier to revisit what you captured without manually retracing folders and threads.',
            'Review emails can be enabled separately, and email opt-out links now leave the in-app review history available.'
        ]
    },
    {
        id: '2026-07-13-search-and-workflow-polish',
        date: '2026-07-13',
        dateLabel: 'July 13, 2026',
        title: 'Search and workflow polish',
        summary:
            'A set of smaller improvements makes search results more precise and everyday actions across messages, boards, and transcription flows less brittle.',
        changes: [
            'Search is more accurate for exact phrases, descriptions, and highlighted matches, while AI chat prompts and replies stay out of default search results.',
            'Transcription confirmations and delete messaging are clearer when actions affect larger sets of notes or thread replies.',
            'Board polish, folder ordering, and several media and URL preview flows are smoother and more predictable.'
        ]
    },
    {
        id: '2026-07-09-smarter-saves-and-reading',
        date: '2026-07-09',
        dateLabel: 'July 9, 2026',
        title: 'Smarter saving, quotes, and reading views',
        summary:
            'Saving links and reading saved material now preserves more context, handles duplicates better, and keeps highlights visually connected.',
        changes: [
            'Save multiple messages in one request while skipping or bumping duplicates more reliably.',
            'Quoted links and saved articles render more cleanly, including richer markdown formatting and clearer preview layouts.',
            'Highlights now keep their color through linked quote messages, making related context easier to recognize at a glance.',
            'URL previews, article views, and quoted metadata handle media, markdown, and link actions more consistently.'
        ]
    },
    {
        id: '2026-06-26-mobile-reliability',
        date: '2026-06-26',
        dateLabel: 'June 26, 2026',
        title: 'Mobile reliability and polish',
        summary:
            'The mobile app now delivers more reliable downloads, smoother media workflows, and more consistent navigation across message screens.',
        media: {
            type: 'image',
            src: 'https://luckynote.s3.eu-central-1.amazonaws.com/static/og-images/luckynote-og-2026.png',
            alt: 'Mobile app release preview',
            caption: 'More reliable file downloads, smoother previews, and clearer quick actions on mobile.'
        },
        changes: [
            'File downloads and opening shared content work more reliably.',
            'Transcription, media previews, and quick file actions are smoother and clearer.',
            'Search results and folder views are more accurate after moving messages.',
            'Message input, back handling, and bottom-sheet flows feel more stable.',
            'Reply/edit flows and message actions are more consistent across screens.',
            'Multiple UI fixes improve spacing, previews, progress feedback, and general responsiveness.'
        ]
    },
    {
        id: '2026-06-24-app-updates',
        date: '2026-06-24',
        dateLabel: 'June 24, 2026',
        title: 'Smoother, safer app updates',
        summary:
            'Luckynote now makes new versions easier to discover and reduces stale-version problems after a deployment.',
        media: {
            type: 'image',
            src: 'https://luckynote.s3.eu-central-1.amazonaws.com/static/changelog/2026-06-24-app-updates/update-available.svg',
            alt: 'Luckynote sidebar showing an update available notice',
            caption: 'New versions remain visible in the sidebar until you choose to update.'
        },
        changes: [
            'A persistent update notice appears in the sidebar when a new version is ready.',
            'The update notice can take you directly to the latest release notes.',
            'App pages and the service worker now refresh reliably while versioned assets remain efficiently cached.',
            'Missing old app files return a clear response instead of being mistaken for executable JavaScript.'
        ]
    },
    {
        id: '2026-06-23-flexible-workspace',
        date: '2026-06-23',
        dateLabel: 'June 23, 2026',
        title: 'Your workspace, your view',
        summary:
            'A broad workspace update makes it faster to move between folders and shape how every collection of messages looks.',
        media: {
            type: 'image',
            src: 'https://luckynote.s3.eu-central-1.amazonaws.com/static/changelog/2026-06-23-flexible-workspace/screenshot-2026-06-24-at-11-59-28.jpeg',
            alt: 'Luckynote Pictures folder displayed in Masonry view',
            caption: 'Masonry view turns mixed notes, images, and saved links into a visual workspace.'
        },
        changes: [
            'Switch between Chat, List, Masonry, and Board views where available.',
            'Choose card size and which fields appear, including images, files, titles, text, URL previews, types, extensions, and tags.',
            'Browse sortable Stacks and Types for content such as PDFs, voice notes, videos, links, images, tasks, and threads.',
            'Jump back into recent folders, create folders with an emoji, and reorder navigation to match your workflow.',
            'Jump directly to a date in a long message history.',
            'Preview PDFs more clearly and open or download saved media from a consistent file menu.'
        ]
    },
    {
        id: '2026-06-21-smart-entities',
        date: '2026-06-21',
        dateLabel: 'June 21, 2026',
        title: 'Luckynote understands more of what you save',
        summary:
            'Saved content can now surface recognizable people, places, media, products, and other useful entities directly on messages.',
        changes: [
            'Messages can display compact badges for books, movies, TV shows, articles, products, events, recipes, places, apps, music, podcasts, tutorials, and more.',
            'Open an entity from a message or use it to start a focused search.',
            'Movie and TV mentions can include a poster, release year, description, and external reference.',
            'Entity details update in real time as Luckynote finishes analyzing newly saved content.',
            'Image-based notes, including HEIC uploads, can contribute to entity recognition.'
        ]
    },
    {
        id: '2026-06-19-thread-and-upload-workflows',
        date: '2026-06-19',
        dateLabel: 'June 19, 2026',
        title: 'Faster thread and upload workflows',
        summary:
            'Moving content into conversations, attaching files, and correcting thread organization now require fewer steps.',
        changes: [
            'Drag messages directly into chat and thread sections using clear drop targets.',
            'Detach a thread message and return it to the main message list.',
            'Drop files into the upload preview before sending and review them in a cleaner attachment layout.',
            'Attach files and images more smoothly while working inside a thread.',
            'Expand long links only when needed, while keeping compact messages easy to scan.',
            'Large raw web clips fall back to readable plain text instead of overwhelming the note preview.'
        ]
    },
    {
        id: '2026-06-17-audio-transcription',
        date: '2026-06-17',
        dateLabel: 'June 17, 2026',
        title: 'Turn audio and video into useful notes',
        summary:
            'Transcription is now a first-class action for voice notes, uploaded audio, supported video links, and AI conversations.',
        changes: [
            'Transcribe an audio message into plain text or create a summary with the full transcript below it.',
            'See clear processing status while longer transcription jobs continue in the background.',
            'Extract transcripts from supported YouTube links directly into the saved note.',
            'Use a recorded voice note as text context before sending it into AI chat.',
            'Audio keeps a readable display name while Luckynote manages the underlying stored file safely.'
        ]
    },
    {
        id: '2026-06-12-ai-chat-context',
        date: '2026-06-12',
        dateLabel: 'June 12, 2026',
        title: 'AI chat keeps more context and loses fewer replies',
        summary:
            'AI conversations are more durable and can make better use of the files, images, links, and messages you reference.',
        changes: [
            'AI replies are saved on the server so they can survive a temporary disconnect or closed browser.',
            'Referenced images and files can be included as real model context when the selected model supports them.',
            'URL metadata and resolved images provide richer context for questions about saved links.',
            'Conversation turns stay in a simpler chronological structure under the original message.',
            'OpenAI file-backed attachments are available again for supported chat models.'
        ]
    },
    {
        id: '2026-06-05-message-history-and-reminders',
        date: '2026-06-05',
        dateLabel: 'June 5, 2026',
        title: 'Restore past messages and act on reminders',
        summary:
            'Important edits are easier to recover, and reminders now leave behind something actionable.',
        changes: [
            'Open version history for supported messages, preview an earlier version, and restore it when needed.',
            'Version previews can include message text, metadata, images, and attachments.',
            'A fired reminder creates a task so the follow-up remains visible after the notification.',
            'Manually moving a message clears outdated AI folder suggestions.',
            'Image preview and lightbox menus provide more consistent open, copy, download, and navigation actions.',
            'Browser extension and mobile download links are easier to find from inside Luckynote.'
        ]
    },
    {
        id: '2026-05-24-account-and-layout-controls',
        date: '2026-05-24',
        dateLabel: 'May 24, 2026',
        title: 'More control over layouts and your account',
        summary:
            'Shared message views gained consistent layout controls, alongside a clearer and safer account deletion flow.',
        changes: [
            'Use the same List, Masonry, and Board controls across shared views such as Stars, Tasks, Recent, reminders, and hierarchy.',
            'Adjust masonry card size and keep the preferred layout for each view.',
            'Copy multiple selected search results with the standard keyboard shortcut.',
            'Delete your account through a confirmation flow and receive a clear completion screen.',
            'Compact note previews remain open more reliably while using folder and search overlays.'
        ]
    },
    {
        id: '2026-05-14-chat-with-folders',
        date: '2026-05-14',
        dateLabel: 'May 14, 2026',
        title: 'Ask questions across an entire folder',
        summary:
            'Folder chat can retrieve relevant notes from a collection, giving AI a broader view than a single message or thread.',
        changes: [
            'Open AI chat inside a folder and ask questions about the notes collected there.',
            'Luckynote retrieves the most relevant folder content instead of sending every message blindly.',
            'Continue a folder conversation without losing the retrieved context between replies.',
            'Referenced messages remain connected to the answer so it is easier to trace where the information came from.'
        ]
    },
    {
        id: '2026-05-10-reminders-and-deep-links',
        date: '2026-05-10',
        dateLabel: 'May 10, 2026',
        title: 'Turn any message into a reminder',
        summary:
            'Messages can now come back at the right time, with clearer scheduling, delivery options, and direct links to the original note.',
        changes: [
            'Set a reminder from a message using quick dates or a custom date and time.',
            'Add a short reminder message so the notification explains what needs attention.',
            'Choose the appropriate delivery option and keep reminder times aligned with your timezone.',
            'Browse upcoming reminders from a dedicated view.',
            'Open notification and email links directly to the relevant folder and message.'
        ]
    },
    {
        id: '2026-05-03-reusable-chat-actions',
        date: '2026-05-03',
        dateLabel: 'May 3, 2026',
        title: 'Create reusable actions for AI chat',
        summary:
            'Frequently used prompts can become named slash actions, making repeatable AI workflows faster to run and easier to manage.',
        changes: [
            'Type a slash command in chat to find and run an available action.',
            'Create custom actions for recurring work such as summarizing, rewriting, extracting, or formatting.',
            'Edit and delete personal actions from Settings.',
            'Use actions with the current message, thread, or chat context instead of rebuilding the same prompt each time.'
        ]
    },
    {
        id: '2026-04-22-document-aware-ai',
        date: '2026-04-22',
        dateLabel: 'April 22, 2026',
        title: 'Bring documents into the conversation',
        summary:
            'PDFs and other supported documents can provide usable text context when you ask AI about a saved file.',
        changes: [
            'Luckynote extracts readable text from supported documents in the background.',
            'Ask questions in a document thread without manually copying the file contents into chat.',
            'AI receives relevant chunks from the original document alongside the conversation.',
            'Longer PDFs are processed more reliably and remain connected to their saved message.'
        ]
    },
    {
        id: '2026-04-10-slack-and-telegram-sharing',
        date: '2026-04-10',
        dateLabel: 'April 10, 2026',
        title: 'Move notes between Luckynote, Slack, and Telegram',
        summary:
            'Connected messaging accounts make it easier to send useful notes and images where a conversation is already happening.',
        changes: [
            'Connect Slack from the Integrations settings.',
            'Send a saved Luckynote message to Slack or Telegram from its message menu.',
            'Forward images together with the message text instead of sharing an incomplete note.',
            'Use the Luckynote bots to capture supported incoming messages back into your workspace.'
        ]
    },
    {
        id: '2026-04-08-richer-notes-and-ai-models',
        date: '2026-04-08',
        dateLabel: 'April 8, 2026',
        title: 'Write richer notes and choose the right AI model',
        summary:
            'The note editor became more capable, while AI chat gained a clearer model picker for different tasks.',
        changes: [
            'Edit Markdown notes in a dedicated rich editing experience.',
            'Preview headings, lists, links, code, quotes, and other Markdown more consistently.',
            'Choose from the AI models available to your account directly inside chat.',
            'Keep the selected model attached to the conversation so later replies use the intended provider.'
        ]
    },
    {
        id: '2026-04-04-search-by-source',
        date: '2026-04-04',
        dateLabel: 'April 4, 2026',
        title: 'Narrow search by source and exact phrase',
        summary:
            'Search gained more precise controls for finding a saved item when you remember where it came from or the wording it used.',
        changes: [
            'Use domain chips to focus results on a specific website or source.',
            'Match exact phrases more reliably when broad keyword search returns too much.',
            'Combine text search with content stacks and other filters.',
            'Keep source filtering strict so similarly named domains do not leak into the results.'
        ]
    },
    {
        id: '2026-04-01-better-reddit-saves',
        date: '2026-04-01',
        dateLabel: 'April 1, 2026',
        title: 'Save more complete Reddit posts',
        summary:
            'Reddit links now preserve more of the original post, including gallery media and structured post data.',
        changes: [
            'Display Reddit galleries with their available images instead of a single incomplete preview.',
            'Resolve more Reddit share and shortened links before building the saved preview.',
            'Use Reddit post images as input for supported AI analysis.',
            'Download the structured Reddit post data when you need an archival copy.'
        ]
    },
    {
        id: '2026-03-20-message-threads',
        date: '2026-03-20',
        dateLabel: 'March 20, 2026',
        title: 'Keep related work together with threads',
        summary:
            'Messages can become focused conversations that hold replies, files, tasks, and AI work without crowding the main folder.',
        changes: [
            'Open a message as a thread and continue the conversation beneath the original note.',
            'Attach existing messages to a thread and move content between the main list and conversation.',
            'Filter folders by thread and conversation activity.',
            'Edit, select, star, move, and manage thread messages with the same core actions used elsewhere.',
            'Use the original message and selected references as context for AI replies inside the thread.'
        ]
    },
    {
        id: '2026-03-15-pdf-preview-and-raycast',
        date: '2026-03-15',
        dateLabel: 'March 15, 2026',
        title: 'Preview PDFs and capture from Raycast',
        summary:
            'Documents became easier to recognize in a folder, and Mac users gained a faster keyboard-first path into Luckynote.',
        changes: [
            'See a generated thumbnail for supported PDFs before opening the file.',
            'Preview PDFs inside Luckynote instead of downloading every document first.',
            'Use the Raycast extension to create a quick note or save a message.',
            'Connect the extension to your Luckynote account for fast capture without opening the full app.'
        ]
    },
    {
        id: '2026-03-10-link-media-tools',
        date: '2026-03-10',
        dateLabel: 'March 10, 2026',
        title: 'Extract media and transcripts from saved links',
        summary:
            'Supported video and social links gained tools for inspecting available media, downloading a useful format, and saving spoken content as text.',
        changes: [
            'Inspect available video or audio formats for a supported saved link.',
            'Choose media quality before starting an extraction or download.',
            'Extract a transcript and keep it in a dedicated tab on the saved message.',
            'Pull audio from an uploaded video and transcribe it.',
            'Handle additional sources such as TikTok links through the same media tools workflow.'
        ]
    },
    {
        id: '2026-02-27-search-large-libraries',
        date: '2026-02-27',
        dateLabel: 'February 27, 2026',
        title: 'Search larger libraries without losing your place',
        summary:
            'A rebuilt search flow made full-text discovery and structured filtering more predictable as a Luckynote library grows.',
        changes: [
            'Switch between full-text search and filter-based browsing.',
            'Load additional results with stable paging instead of seeing repeated or skipped messages.',
            'Search across recent content while combining text, type, and folder constraints.',
            'Return to search results with fewer layout jumps and stale result states.'
        ]
    },
    {
        id: '2026-02-16-ai-organization',
        date: '2026-02-16',
        dateLabel: 'February 16, 2026',
        title: 'Let AI organize the notes waiting in your inbox',
        summary:
            'Luckynote can suggest destinations for new material and process pending organization work when the workspace is quiet.',
        changes: [
            'Receive folder suggestions for supported new messages.',
            'Review suggested destinations before deciding where a note belongs.',
            'Move a message manually when you want to override the suggestion.',
            'Enable nightly AI organization from your account settings.',
            'Keep recently active inbox work from being reorganized while you are still using it.'
        ]
    },
    {
        id: '2026-02-10-x-bookmarks',
        date: '2026-02-10',
        dateLabel: 'February 10, 2026',
        title: 'Bring X bookmarks into Luckynote',
        summary:
            'The X integration can connect your account and turn bookmarked posts into searchable material in your workspace.',
        changes: [
            'Connect an X account securely through the Integrations settings.',
            'Import supported bookmarks without manually sharing each post.',
            'Preserve useful post text, links, and media metadata in the saved message.',
            'Disconnect the integration from Luckynote whenever you no longer want it linked.'
        ]
    },
    {
        id: '2026-01-27-ai-and-transcription',
        date: '2026-01-27',
        dateLabel: 'January 27, 2026',
        title: 'Meet Luckynote AI and searchable transcripts',
        summary:
            'AI chat, writing actions, and audio transcription arrived together as tools for working directly with saved knowledge.',
        changes: [
            'Chat with AI from inside Luckynote and keep the conversation alongside your notes.',
            'Summarize, translate, improve, extract key points, generate text, and ask questions.',
            'Transcribe saved audio using a supported Luckynote or connected provider.',
            'Read transcripts as timestamped segments and click a segment to seek to that moment in the audio.',
            'See AI credit usage in the product before running additional work.'
        ]
    },
    {
        id: '2026-01-15-desktop-app',
        date: '2026-01-15',
        dateLabel: 'January 15, 2026',
        title: 'Luckynote comes to the desktop',
        summary:
            'A native desktop app brought the core Luckynote workspace to Mac and Windows with local file handling and large uploads.',
        changes: [
            'Use Luckynote in a dedicated desktop window instead of keeping another browser tab open.',
            'Sign in to the same synced workspace used on web and mobile.',
            'Open and download saved files through native desktop controls.',
            'Upload large files using multipart transfers designed to recover more gracefully from interruptions.',
            'Receive desktop app updates without reinstalling the application manually.'
        ]
    },
    {
        id: '2025-12-19-large-file-workflows',
        date: '2025-12-19',
        dateLabel: 'December 19, 2025',
        title: 'Upload and download large files with confidence',
        summary:
            'File transfers became easier to prepare, monitor, and recover, especially when working with several attachments or larger media.',
        changes: [
            'Upload large files in multiple parts instead of restarting the entire transfer after an interruption.',
            'See a new file message immediately while its upload continues in the background.',
            'Add several files at once and drag them into the order you want before sending.',
            'Check file-size limits before uploading and see a clear upgrade path when more storage is required.',
            'Follow visible progress while downloading larger files and images.'
        ]
    },
    {
        id: '2025-12-09-instant-message-updates',
        date: '2025-12-09',
        dateLabel: 'December 9, 2025',
        title: 'Messages respond immediately and remember your place',
        summary:
            'A broad reliability update made everyday actions feel faster while preserving context as you move between folders and search results.',
        changes: [
            'New and edited messages update on screen immediately while Luckynote confirms the change.',
            'Retry a message when a temporary connection problem prevents it from saving.',
            'Delete, trash, restore, move, star, and complete tasks without waiting for a full folder reload.',
            'Return to the previous scroll position in regular folders, Stars, and Tasks.',
            'Open a search result with surrounding messages for clearer context.',
            'See newly synced content through automatic folder refreshes.'
        ]
    },
    {
        id: '2025-11-15-telegram-capture',
        date: '2025-11-15',
        dateLabel: 'November 15, 2025',
        title: 'Capture notes directly from Telegram',
        summary:
            'Telegram became another Luckynote inbox, making it possible to save material while already chatting or sharing from a phone.',
        changes: [
            'Link a Telegram account from the Integrations settings.',
            'Send text messages to the Luckynote bot to create new notes.',
            'Forward photos, documents, audio, and voice messages into your workspace.',
            'Keep batches of incoming Telegram messages in their original order.',
            'Receive a visible confirmation or error response after the bot processes an item.'
        ]
    },
    {
        id: '2025-10-25-link-video-tools',
        date: '2025-10-25',
        dateLabel: 'October 25, 2025',
        title: 'Keep videos from saved links',
        summary:
            'Supported video links gained controls for preserving the media with a note instead of depending on the original post forever.',
        changes: [
            'Recognize supported video media and show it inside the saved link preview.',
            'Save a linked video as an attachment on the current message.',
            'Create a separate message from the discovered video when you want to organize it independently.',
            'Prepare and download an available video from the media tools panel.',
            'Preserve video details such as dimensions, duration, and audio availability when the source provides them.'
        ]
    },
    {
        id: '2025-09-15-richer-reddit-previews',
        date: '2025-09-15',
        dateLabel: 'September 15, 2025',
        title: 'Reddit saves become useful notes',
        summary:
            'Reddit links started preserving the post details needed to understand and find them later, rather than appearing as generic URLs.',
        changes: [
            'Show the post title, author, subreddit, description, and available preview image.',
            'Resolve supported Reddit links through authenticated post data when a basic webpage preview is incomplete.',
            'Recognize Reddit-hosted video details for playback and later saving.',
            'Keep a fallback path for posts where the primary Reddit metadata source is unavailable.'
        ]
    },
    {
        id: '2025-08-23-audio-notes',
        date: '2025-08-23',
        dateLabel: 'August 23, 2025',
        title: 'Listen to audio inside your workspace',
        summary:
            'Audio files became a first-class message type with dedicated filtering and more useful playback controls.',
        changes: [
            'Filter a folder to show saved audio messages.',
            'Play common audio formats, including supported OGG files, without leaving Luckynote.',
            'Change playback speed between 1x, 1.5x, and 2x.',
            'Control volume, mute playback, loop an audio file, and seek through its timeline.',
            'See elapsed and total duration while listening.'
        ]
    },
    {
        id: '2025-08-02-link-image-previews',
        date: '2025-08-02',
        dateLabel: 'August 2, 2025',
        title: 'See the image behind a saved link',
        summary:
            'Rich image previews for saved URLs became available across Luckynote, making visual links easier to recognize at a glance.',
        changes: [
            'Fetch a representative image and page metadata when saving a supported link.',
            'Display visual previews for every account instead of limiting enhanced link images to administrators.',
            'Use the preview to distinguish image-heavy articles, products, places, and media before opening the source.'
        ]
    }
];

module.exports = {
    CHANGELOG_ENTRIES
};
